function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}><title>button / circle / minus</title><g fillRule="nonzero" fill="#42444C"><path d="M9 18A9 9 0 1 1 9 0a9 9 0 0 1 0 18zm0-2A7 7 0 1 0 9 2a7 7 0 0 0 0 14z" /><path d="M19.707 18.293a1 1 0 0 1-1.414 1.414l-4.35-4.35a1 1 0 0 1 1.414-1.414l4.35 4.35zM6 10a1 1 0 1 1 0-2h6a1 1 0 0 1 0 2H6z" /></g></svg>;
});